// @ts-nocheck
import { TrackItemOutOfStockErrorParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackItemOutOfStockError";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const useTrackItemOutOfStockError = (
    parameters: TrackItemOutOfStockErrorParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.itemOutOfStockError, parameters, options);
};

export default useTrackItemOutOfStockError;
